import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Loader2, ArrowLeft, CheckCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  function submit(e) {
    e.preventDefault();
    setLoading(true);
    axios.post(`${API_URL}/api/auth/forgot-password`, { email })
      .then(() => setSent(true))
      .catch(() => setSent(true)) // réponse générique volontaire
      .finally(() => setLoading(false));
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center pt-20 px-4">
      <div className="w-full max-w-md bg-zinc-900/50 border border-white/10 rounded-2xl p-8">
        <button onClick={() => navigate('/login')} className="flex items-center gap-1 text-zinc-400 hover:text-white text-sm mb-6">
          <ArrowLeft className="h-4 w-4" /> {t('forgotPw.backToLogin')}
        </button>

        {sent ? (
          <div className="text-center">
            <CheckCircle className="h-12 w-12 text-emerald-400 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-white mb-2">{t('forgotPw.checkMail')}</h1>
            <p className="text-zinc-400 text-sm">
              {t('forgotPw.sentIfExists', { email: email })}
            </p>
            <button onClick={() => navigate('/login')} className="mt-6 rounded-full bg-[#F9004D] hover:bg-[#D00040] text-white font-bold px-6 py-3">
              {t('forgotPw.backToLoginBtn')}
            </button>
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Syne, sans-serif' }}>{t('forgotPw.title')}</h1>
            <p className="text-zinc-400 text-sm mb-6">{t('forgotPw.subtitle')}</p>
            <form onSubmit={submit} className="space-y-4">
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-zinc-500" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t('forgotPw.emailPlaceholder')}
                  required
                  className="w-full bg-black/20 border border-white/10 text-white rounded-lg pl-10 py-3.5 focus:outline-none focus:border-[#F9004D]"
                  data-testid="forgot-email"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full rounded-full bg-[#F9004D] hover:bg-[#D00040] text-white font-bold py-3.5 disabled:opacity-50 flex items-center justify-center gap-2"
                data-testid="forgot-submit"
              >
                {loading && <Loader2 className="h-4 w-4 animate-spin" />}
                {t('forgotPw.sendLink')}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
